// Bus d'activité partagé : une seule source d'événements pour la bannière (SocialProof)
// et la carte des flux (MapDesLueurs) — ainsi les deux restent parfaitement synchronisés.
import { COUNTRIES } from "@/lib/activityData";

const subscribers = new Set();
let timer = null;

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

function buildEvent() {
  const c = pick(COUNTRIES);
  const city = pick(c.cities);
  const name = pick(c.first);
  return {
    id: Math.random().toString(36).slice(2),
    flag: c.flag,
    country: c.name,
    name,
    initial: name.charAt(0),
    city: city.name,
    coords: city.coords,
    useSignup: Math.random() < 0.18,
    ts: Date.now(),
  };
}

function tick() {
  const ev = buildEvent();
  subscribers.forEach((cb) => { try { cb(ev); } catch { /* noop */ } });
  timer = setTimeout(tick, 15000 + Math.random() * 18000); // 15–33 s
}

export function subscribeActivity(cb) {
  subscribers.add(cb);
  if (timer === null) {
    timer = setTimeout(tick, 6000); // premier événement après 6 s
  }
  return () => {
    subscribers.delete(cb);
    if (subscribers.size === 0 && timer) {
      clearTimeout(timer);
      timer = null;
    }
  };
}
